module.exports = __webpack_public_path__ + "img/07.35f22b42.jpg";